const styles = {
  container: {
    width: '100%',
    minWidth: '275px',
    maxWidth: '350px',
    backgroundColor: 'white',
    borderRight: '1px solid #e5e7eb',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column' as const,
    height: '100%'
  },
  
  logoSection: {
    marginBottom: '.5rem'
  },
  logoImage: {
    width: '180px'
  },
  
  workspaceSelector: {
    marginBottom: '1rem',
    padding: '0.5rem',
    backgroundColor: '#f9fafb',
    borderRadius: '0.5rem'
  },
  workspaceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  profileImage: {
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    // objectFit: 'cover',
    // transform: 'translate(-50%, -50%)'
  },
  profileName: {
    fontSize: '0.875rem',
    fontWeight: '500'
  },
  profileType: {
    fontSize: '0.75rem',
    color: '#6b7280'
  },
  
  navigation: {
    flex: '1',
    // gap: '0.25rem',
    display: 'flex',
    flexDirection: 'column' as const
  },
  navLink: (isActive: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    backgroundColor: isActive ? '#ccccff' : 'transparent',
    color: isActive ? 'black' : '#374151',
    '&:hover': {
      backgroundColor: isActive ? '#E0D9FF' : '#f9fafb'
    }
  }),
  
  metricsContainer: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '1rem',
    marginBottom: '1rem'
  },
  metricItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '0.25rem'
  },
  metricHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.25rem'
  },
  metricIcon: {
    marginBottom: '-0.5rem'
  },
  metricText: {
    fontSize: '0.75rem',
    color: '#5C5C5C',
    marginTop: '0.25rem'
  },
  progressBar: {
    height: '0.5rem',
    backgroundColor: '#e5e7eb',
    borderRadius: '9999px',
    overflow: 'hidden'
  },
  progressFill: {
    height: '100%',
    borderRadius: '9999px'
  },
  progressGradient: {
    width: '100%',
    background: 'linear-gradient(90deg, #A5A1FF 0%, #A595DE 50%, #5A3DB4 100%)'
  },
  
  bottomActions: {
    marginTop: '.5rem',
    display: 'flex',
    flexDirection: 'column' as const,
    // gap: '0.25rem'
  },
  primaryButton: {
    width: '100%',
    backgroundColor: '#7772FF',
    color: 'white',
    padding: '0.5rem 0',
    borderRadius: '0.5rem'
  },
  secondaryButton: {
    width: '100%',
    color: '#374151',
    padding: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    borderRadius: '0.5rem',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer'
  },
  
  secondaryButtonHover: {
    backgroundColor: '#E0D9FF',
    color: '#5A3DB4'
  },
  buttonIcon: {
    width: '20px',
    height: '20px'
  },
  buttonText: {
    fontSize: '0.875rem',
    fontWeight: '500'
  },
  navIcon: {
    width: '25px',
    height: '25px',
    marginRight: '8px'
  }
};

export default styles;